import ChargeHelper from 'features/Charge/chargeHelper';
import KTLabel, { KTLabelSize } from 'general/components/OtherKeenComponents/KTLabel';
import AppColors from 'general/constants/AppColors';
import AppRoute from 'general/constants/AppRoute';
import UIHelper from 'general/helpers/UIHelper';
import Utils from 'general/utils/Utils';
import _ from 'lodash';
import PropTypes from 'prop-types';
import ShowMoreText from 'react-show-more-text';

DialogFleetTransactionDetailView.propTypes = {
  item: PropTypes.object.isRequired,
  user: PropTypes.object,
  onCancel: PropTypes.func,
};

function DialogFleetTransactionDetailView({ item, onDone, user }) {
  // MARK: ---- PROPERTIES ----
  const row = item;

  return (
    <div className="p-4">
      <div className='' style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}>
        Thông tin cơ bản
      </div>
      <div style={{ backgroundColor: AppColors.gray[100] }}>
        {UIHelper.buildSectionCard(
          <div
            className=""
            style={{
              backgroundColor: 'white',
              borderRadius: '5px',
              overflow: 'hidden',
            }}
          >
            {UIHelper.buildCardCellItem(
              'Mã giao dịch',
              row?.walletTransactionCode ?? row?.walletTransactionId?.toString(),
            )}
            {UIHelper.buildCardCellItem(
              'Mã giao dịch tham chiếu/Phiên sạc',
              row?.externalTransactionCode ?? row?.externalTransactionId,
              () => {
                if (row?.amount < 0) {
                  Utils.openInNewTab(`${AppRoute.chargeTransactionList}/${row?.externalTransactionId}`)
                }
              }
            )}
            {UIHelper.buildCardCellItem(
              'Người thực hiện',
              row?.wallet?.user?.fullname,
              () => {
                if (row?.forRole === 'FLEET') {
                  if (adminRole) {
                    Utils.openInNewTab(`${AppRoute.fleetList}/${row?.wallet?.user?.agencyId}`)
                  } else {
                    Utils.openInNewTab(`${AppRoute.fleetInfo}/${row?.wallet?.user?.agencyId}`)
                  }
                } else {
                  if (adminRole) {
                    Utils.openInNewTab(`${AppRoute.customerList}/${row?.wallet?.userId}`)
                  } else {
                    Utils.openInNewTab(`${AppRoute.driverList}/${row?.wallet?.userId}`)
                  }
                }
              }
            )}
            {UIHelper.buildCardCellItem(
              'Loại đối tượng',
              row?.forRole === 'FLEET' ? 'Doanh nghiệp VT' : 'Tài xế',
            )}
            {UIHelper.buildCardCellItem(
              'Loại giao dịch',
              ChargeHelper.Utils.getDriverTransactionName(row?.fundingSource),
            )}
            {UIHelper.buildCardCellItem(
              'Số tiền',
              !_.isNil(row?.amount)
                ? (_.toNumber(row?.amount) > 0 ? '+' : '') + Utils.formatNumber(row?.amount) + ' VNĐ'
                : '',
              null,
              true,
              _.toNumber(row?.amount) > 0 ? AppColors.primary : AppColors.danger,
            )}
            {UIHelper.buildCardCellItem(
              'Thời gian',
              !_.isNil(row?.time)
                ? Utils.formatDateTimeToString(row?.time, 'DD/MM/YYYY - HH:mm')
                : ''
            )}
            {UIHelper.buildCardCellItem(
              'Phương thức thanh toán',
              ChargeHelper.Utils.getChargePaymentMethodName(row?.fundingSource) ?? ''
            )}
            {UIHelper.buildCardCellItem(
              'Trạng thái',
              <KTLabel
                text={ChargeHelper.Utils.getWalletTransactionStatusName(row?.status)}
                isInline={true}
                size={KTLabelSize.medium}
                additionalClassName={`label-light-${ChargeHelper.Utils.getWalletTransactionStatusColor(
                  row?.status
                )}`}
              />,
              null,
              false
            )}
          </div>
        )}
      </div>

      <div className=' mt-4' style={UIHelper.buildFontStyle('600', '14px', AppColors.gray[900])}>
        Nội dung
      </div>
      {UIHelper.buildSectionCard(
        <div
          className="px-3 py-2"
          style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[700])}
        >
          <ShowMoreText
            lines={3}
            more="Xem thêm"
            less="Thu gọn"
            className="text-break"
            anchorClass="text-success font-size-normal font-weight-bolder cursor-pointer hover-opacity-60"
            onClick={() => { }}
            expanded={false}
            truncatedEndingComponent={'... '}
          >
            {row?.description}
          </ShowMoreText>
        </div>
      )}
    </div>
  );
}

export default DialogFleetTransactionDetailView;
